var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "avatar-uploader",
      attrs: {
        action: "https://jsonplaceholder.typicode.com/posts/",
        "show-file-list": false,
        "http-request": _vm.uploadImage
      }
    },
    [
      _vm.imageUrl
        ? _c("img", {
            staticClass: "avatar",
            staticStyle: { "object-fit": "contain" },
            attrs: { src: _vm.imageUrl }
          })
        : _c("span", { staticClass: "avatar-uploader-icon" }, [
            _vm._v(_vm._s(_vm.label))
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }